/** 
 * Restrict characters in the chips component.
 */

import { Directive, HostListener, Input } from '@angular/core';

@Directive({ selector: '[appChips]', exportAs: 'appChips' })
export class ChipsDirective {

  @Input('delimiter') delimiter!: string;

  @HostListener('keypress', ['$event'])
  public onKeypress(e: KeyboardEvent) {
    if (this.delimiter && this.delimiter.length > 0) {
      if (e.key === this.delimiter[0]) {
        e.preventDefault();
        return;
      }
    }
  }

  @HostListener('paste', ['$event'])
  public onPaste(event: ClipboardEvent) {
    const txt = event.clipboardData?.getData('text');
    if (this.delimiter && this.delimiter.length > 0) {
      if (txt?.includes(this.delimiter[0])) {
        event.preventDefault();
      }
    }
  }
}